import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ErrorComponent } from './common/error/error.component';
import { LoginComponent } from './common/login/login.component';
import { UnauthorizedComponent } from './common/unauthorized/unauthorized.component';
import { ClientFileConfigurationComponent } from './client_file_configuration/client-file-configuration/client-file-configuration.component';
import { ContactDataComponent } from './components/enrollment/contact-data/contact-data.component';
import { DocumentDetailsComponent } from './components/enrollment/document-details/document-details.component';
import { EnrollmentGuard } from './_guard/enrollment.guard';
import { AuthGuard } from './_guard/auth.guard';
import { LoginGuard } from './_guard/login.guard';
import { PwrecoveryComponent } from './common/login/pwrecovery/pwrecovery.component';
import { PwresetComponent } from './common/login/pwreset/pwreset.component';
import { FileFormComponent } from './components/file-form/file-form.component';
import { DocumentsComponent } from './components/enrollment/documents/documents.component';
import { DisputeDetailsComponent } from './components/disputes/details/dispute-details.component';
import { DisputesComponent } from './components/disputes/disputes.component';
import { ProfileComponent } from './components/profile/profile.component';
import { HelpComponent } from './components/help/help.component';
import { LogoutComponent } from './common/logout/logout.component';
import { SsoComponent } from './common/login/sso/sso.component';
import { DashboardComponent } from './common/dashboard/dashboard.component';
import { EndEnrollmentComponent } from './components/enrollment/end-enrollment/end-enrollment.component';

const routes: Routes = [
  {
    path: '', component: DisputesComponent,
    canActivate: [AuthGuard, EnrollmentGuard],
    title: 'title_DCO.Title_Disputes'
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard, EnrollmentGuard],
    title: 'title_DCO.Title_Home'
  },
  {
    path: 'hel',
    component: HomeComponent,
    canActivate: [AuthGuard, EnrollmentGuard],
  },
  { path: 'error', component: ErrorComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'login/sso', component: SsoComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: 'login', component: LoginComponent,
    title: 'title_DCO.Title_Login'

  },
  {
    path: 'clientfileconfiguration',
    component: ClientFileConfigurationComponent,
    canActivate: [AuthGuard, EnrollmentGuard],
    //title: 'DCO - Configuracion ficheros cliente',
    title: 'title_DCO.Title_FileConfiguration',
  },
  {
    path: 'disputes',
    component: DisputesComponent,
    canActivate: [AuthGuard, EnrollmentGuard],
    //title: 'DCO aaa- Consulta disputas',,
    title: 'title_DCO.Title_Disputes'
  },
  {
    path: 'disputes/state/:state',
    component: DisputesComponent,
    canActivate: [AuthGuard, EnrollmentGuard],
    //title: 'DCO aaa- Consulta disputas',,
    title: 'title_DCO.Title_DisputesStates'
  },
  {
    path: 'disputes/:id', component: DisputeDetailsComponent,
    canActivate: [AuthGuard, EnrollmentGuard],
    title: 'title_DCO.Title_DisputesDetails'
  },
  {
    path: 'contact-data', component: ContactDataComponent,
    canActivate: [AuthGuard],
    title: 'title_DCO.Title_ContactData'
  },
  { path: 'enrollment', 
    component: ContactDataComponent,
    canActivate: [AuthGuard],

  },
  {
    path: 'document-details', component: DocumentsComponent,
    canActivate: [AuthGuard],
    title: 'title_DCO.Title_DocumentDetails'
  },
{
    path: 'end-enrollment', component: EndEnrollmentComponent,
    canActivate: [AuthGuard],
    title: 'title_DCO.Title_EndEnrollment'
  },
  {
    path: 'login/password-recovery', component: PwrecoveryComponent,
    title: 'title_DCO.Title_PasswordRecovery'
  },
  {
    path: 'login/password-reset', component: PwresetComponent,
    title: 'title_DCO.Title_PasswordReset'
  },
  {
    path: 'profile', component: ProfileComponent,
    canActivate: [AuthGuard],
    title: 'title_DCO.Title_Profile'
  },
  {
    path: 'help', component: HelpComponent,
    title: 'title_DCO.Title_Help'
  },
  {
    path: 'dashboard', component: DashboardComponent,
    title: 'title_DCO.Title_Dashboard'
  },
  { path: 'fileform', component: FileFormComponent },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
